import classNames from 'classnames'
import Link from 'next/link'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import styles from './LinkHelper.module.scss'

type Props = {
  block?: boolean
  children: React.ReactNode
  disabled?: boolean
  ellipsis?: boolean
  href: string
  primary?: boolean
  scroll?: boolean
  title?: string
}

const LinkHelper = ({ block, children, disabled, ellipsis, href, primary, scroll, title }: Props) => {
  const myClassNames = classNames(
    styles.container,
    'btn btn-sm',
    { 'btn-block': block, disabled, ellipsis },
    primary ? 'btn-primary' : 'btn-secondary',
  )

  if (disabled) {
    return (
      <OverlayTrigger overlay={<Tooltip id='data'>Not enough data</Tooltip>} placement='top'>
        <div className={myClassNames}>{children}</div>
      </OverlayTrigger>
    )
  }

  return (
    <Link className={myClassNames} href={href} scroll={scroll} title={title}>
      {children}
    </Link>
  )
}

export default LinkHelper
